import { ConfigType, RuleType, TestResultType } from './types';

// as of 2020-08-27, this is what user-management counts as classes:
// class_presence = [
//     any(char.isdigit() for char in word),
//     any(char.islower() for char in word),
//     any(char.isupper() for char in word),
//     any(char in string.punctuation for char in word),
// ]
// return sum(class_presence)
// string.punctuation is '!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~' (inclusive)

// since communicating "pick x of y" to the user is hard, we're going to
// pretend that "pick 3" means "do the first 3". The requirements get met
// even if they could have picked a different password as well

const punctuation = "!#$%&'()*+,-./:;<=>?@[]^_`{|}~" + '"\\';

const specialsValidator = (password: string) => {
  const testArray = punctuation.split('');
  const candidates = password.replace(/[\d\w\s]/g, '').split('');
  const matches = testArray.filter((symbol: string) =>
    candidates.includes(symbol),
  );
  return matches.length > 0;
};

export const getRules = (config: ConfigType) => {
  const rules = [
    {
      label: `Minimum of ${config.minLength} characters`,
      validator: (password: string) => password.length >= config.minLength,
    },
    {
      label: 'At least 1 number',
      validator: (password: string) => /\d/g.test(password),
    },
    {
      label: 'At least 1 uppercase letter',
      validator: (password: string) => /[A-Z]/g.test(password),
    },
    {
      label: 'At least 1 lowercase letter',
      validator: (password: string) => /[a-z]/g.test(password),
    },
    {
      label: 'At least 1 special character',
      validator: specialsValidator,
    },
  ];
  return rules.slice(0, config.classCount + 1);
};

export const getLabels = (config: ConfigType) =>
  getRules(config).map((rule: RuleType) => rule.label);

export const applyRule = (rule: RuleType, password: string) =>
  rule.validator(password);

export const runTests = (config: ConfigType, password: string) => {
  const applyTestResults =
    (passwordApplyTestResults: string) => (rule: RuleType) => ({
      ...rule,
      passed: applyRule(rule, passwordApplyTestResults),
    });
  const results = getRules(config).map(applyTestResults(password));
  return results;
};

export const getErrors = (results: TestResultType[]) =>
  results
    .filter((result: TestResultType) => result.passed === false)
    .map((result: TestResultType) => result.label);
